import { forwardRef, type SVGProps } from 'react';

export const ScaleUnbalancedIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ScaleUnbalancedIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 24 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_11015)">
        <path
          d="M19.8 16.625H13.2V5.68701C13.9658 5.35525 14.5538 4.714 14.8268 3.92543L19.7768 2.28297C20.091 2.17869 20.2601 1.84211 20.1548 1.53113L19.7734 0.405234C19.668 0.0942578 19.3279 -0.0731055 19.0136 0.0311719L14.5916 1.49811C14.0737 0.607109 13.1134 0 12 0C10.3433 0 9 1.32926 9 2.96875C9 3.09604 9.02213 3.21775 9.03788 3.34096L4.22325 4.93852C3.909 5.04279 3.73988 5.37937 3.84525 5.69035L4.22662 6.81625C4.332 7.12723 4.67213 7.29459 4.98638 7.19031L10.3132 5.42279C10.4659 5.52559 10.6294 5.61279 10.8004 5.68701V18.4062C10.8004 18.7343 11.0689 19 11.4004 19H19.8004C20.1319 19 20.4004 18.7343 20.4004 18.4062V17.2188C20.4 16.8907 20.1315 16.625 19.8 16.625ZM23.9993 11.2812C23.9993 10.6808 24.0495 10.9573 20.8099 4.54553C20.148 3.23594 18.2528 3.23334 17.5898 4.54553C14.3228 11.0122 14.4008 10.6997 14.4008 11.2812H14.4C14.4 12.9207 16.5491 14.25 19.2 14.25C21.8509 14.25 24 12.9207 24 11.2812H23.9993ZM16.5 10.6875L19.2 5.34375L21.9 10.6875H16.5ZM6.40987 9.29553C5.748 7.98594 3.85275 7.98334 3.18975 9.29553C-0.0772502 15.7622 0.00075 15.4497 0.00075 16.0312H0C0 17.6707 2.14913 19 4.8 19C7.45088 19 9.6 17.6707 9.6 16.0312H9.59925C9.59925 15.4308 9.6495 15.7073 6.40987 9.29553ZM2.1 15.4375L4.8 10.0938L7.5 15.4375H2.1Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_11015">
          <rect fill="white" height="19" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
});
